// src/services/feedbackService.js
import {FeedbackGameApi} from '@/api/backendService';

/**
 * The channels a player can transmit on. The values are the server's
 * `Feedback.Channel`; the labels are i18n keys the console renders.
 */
export const FEEDBACK_CHANNELS = [
    {value: 'fault', labelKey: 'feedback.channels.fault'},
    {value: 'signal', labelKey: 'feedback.channels.signal'},
    {value: 'idea', labelKey: 'feedback.channels.idea'},
];

export const FEEDBACK_MESSAGE_MAX_LENGTH = 2000;

/**
 * FeedbackService wraps the generated client for the feedback endpoint.
 */
class FeedbackService {
    constructor(api = FeedbackGameApi) {
        this.api = api;
    }

    /**
     * Send one message.
     *
     * Endpoint: POST /api/feedback/messages/
     *
     * @param {Object} payload
     * @param {string} payload.message What the player wrote.
     * @param {string} [payload.channel] One of FEEDBACK_CHANNELS.
     * @param {string} [payload.route] The screen it was written on.
     * @returns {Promise<Object>} The stored message.
     */
    async send({message, channel = 'signal', route = ''}) {
        const body = {message: (message || '').trim(), channel};
        if (route) body.route = route.slice(0, 255);
        return (await this.api.feedbackMessagesCreate(body)).data;
    }
}

export default new FeedbackService();
export {FeedbackService};
